import PropTypes from "prop-types";
import { useState } from "react";
import Slider from "react-slick";
import { RecipeSelectionType } from "../../OrderFlow/OrderFlowProvider/OrderFlowTypes";
import { ItemCard } from "../../Shared/components/ItemCard/ItemCard";
import { ItemCardType } from "../../Shared/components/ItemCard/itemCardUtils";
import { usePriceFormat } from "../../Shared/hooks/usePriceFormat/usePriceFormat";
import { product_default_image, PRODUCT_TYPE } from "../../Shared/utils/constants";
import { productsSliderSettings } from "../../Shared/utils/sliderSettings";
import "../utils/myMealsCSS.css";

ProductRow.propTypes = {
  products: PropTypes.array.isRequired,
  productImageBaseUrl: PropTypes.string.isRequired,
  handleProductQuantityChange: PropTypes.func.isRequired,
  dayConfig: PropTypes.object.isRequired,
  productAndRecipeCardLayoutSettings: PropTypes.object,
  culture: PropTypes.object.isRequired,
  restrictProductQuantitySelection: PropTypes.bool.isRequired,
};

export default function ProductRow(props) {
  const [sliderSettings, setSliderSettings] = useState(productsSliderSettings);
  const { formatPrice } = usePriceFormat();

  return (
    <>
      {props.products && props.products.length > 0 && (
        <Slider {...sliderSettings}>
          {props.products
            .sort((a, b) => {
              if (a.PurchasedQuantity === 0 && b.PurchasedQuantity > 0) {
                return 1;
              }

              if (a.PurchasedQuantity > 0 && b.PurchasedQuantity > 0) {
                return 0;
              }

              if (a.PurchasedQuantity === 0 && b.PurchasedQuantity === 0) {
                return 0;
              }

              if (a.PurchasedQuantity > 0 && b.PurchasedQuantity === 0) {
                return -1;
              }
            })
            .filter((product) => product.ProductType !== PRODUCT_TYPE.OFF_MENU)
            .map((product) => {
              let itemPriceObject = formatPrice({displayPriceOverride: product.ProductPrice});
              let itemSalePriceObject = formatPrice({ displayPriceOverride: product.ProductSalePrice });

              if (product.ProductImages.length < 1) {
                product.ProductImages.push(product_default_image);
              }

              const isProductOnSale = product.ProductSalePrice > 0 && product.ProductSalePrice < product.ProductPrice;

              return (
                <ItemCard
                  key={product.ProductId}
                  itemName={product.ProductName}
                  isAddDisabled={
                    props.restrictProductQuantitySelection ||
                    (!props.dayConfig.CanAddProducts && product.NewQuantity >= product.PurchasedQuantity)
                  }
                  isMinusDisabled={
                    props.restrictProductQuantitySelection ||
                    (!props.dayConfig.CanRemoveProducts && product.NewQuantity <= product.PurchasedQuantity)
                  }
                  handleQuantityIncrement={() =>
                    props.handleProductQuantityChange(product.ProductId, product.NewQuantity + 1)
                  }
                  handleQuantityDecrement={() =>
                    props.handleProductQuantityChange(product.ProductId, product.NewQuantity - 1)
                  }
                  imageBaseUrl={props.productImageBaseUrl}
                  itemImageUrls={product.ProductImages}
                  quantity={
                    product.PurchasedQuantity !== product.NewQuantity ? product.NewQuantity : product.PurchasedQuantity
                  }
                  handleQuantityChange={props.handleProductQuantityChange}
                  sliderSettings={sliderSettings}
                  setSliderSettings={setSliderSettings}
                  itemDescription={product.ProductDescription}
                  itemPriceObject={itemPriceObject}
                  itemSalePrice={isProductOnSale ? itemSalePriceObject.itemPrice : undefined}
                  descriptionLines={3}
                  productAndRecipeCardLayoutSettings={props.productAndRecipeCardLayoutSettings}
                  symbolFlags={[]}
                  recipeFlags={[]}
                  recipeSelectionType={RecipeSelectionType.AssignRecipes}
                  itemType={ItemCardType.Product}
                />
              );
            })}
        </Slider>
      )}
      {(!props.products || props.products.length === 0) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "large",
            fontWeight: "bold",
          }}
        >
          No products to display.
        </div>
      )}
    </>
  );
}
